import { BarChart, Box, Card } from '@factorialco/deprecated-design-system'
import _ from 'lodash'

import DraggableNode from 'modules/core/components/DraggableNode'
import useMouseCoords from 'modules/core/hooks/useMouseCoords'
import i18n from 'modules/core/lib/i18n'

import BlankSlate from 'modules/insights/components/BlankSlate'
import ChartTooltip from 'modules/insights/components/ChartTooltip'
import ChartTooltipPercentage from 'modules/insights/components/ChartTooltipPercentage'
import TooltipLegend from 'modules/insights/components/TooltipLegend'
import useMarginEffect from 'modules/insights/hooks/useMarginEffect'
import magnitude from 'modules/insights/lib/magnitude'
import type AgeRangeDistribution from 'modules/insights/lib/metrics/ageRangeDistribution'

type Props = {
  ageRangeDistribution: AgeRangeDistribution
}

const INDEX_BY = 'range'

const WidgetAgeRangeDistribution = ({ ageRangeDistribution }: Props) => {
  const numEmployeesByAge = ageRangeDistribution.generate()
  const numEmployeesWithoutAgeRanges = numEmployeesByAge.map(({ count }) => Number(count))
  const totalNumberOfEmployees = _.sum(numEmployeesWithoutAgeRanges)
  const max = Math.max(...numEmployeesWithoutAgeRanges)
  const maxY = magnitude(max)

  const left = useMarginEffect(maxY)
  const coordinates = useMouseCoords()

  return (
    <Card>
      <Card.Title tooltip={i18n.t('insights.widgets.age_range_distribution.tooltip')}>
        {i18n.t('insights.widgets.age_range_distribution.title')}
      </Card.Title>
      <Card.Content>
        {ageRangeDistribution.isEmpty() ? (
          <BlankSlate />
        ) : (
          <Box height="s300" width="full">
            <BarChart
              margin={{ top: 30, bottom: 25, left, right: 0 }}
              tooltip={({ label, value }) => {
                return (
                  <DraggableNode coordinates={coordinates}>
                    <ChartTooltip
                      title={i18n.t('insights.widgets.age_range_distribution.bar_tooltip')}
                    >
                      <Box gap="s8">
                        <TooltipLegend
                          color={'champagne600'}
                          name={label.toString()}
                          value={value}
                        />
                        <ChartTooltipPercentage
                          percentage={(value / totalNumberOfEmployees) * 100}
                        />
                      </Box>
                    </ChartTooltip>
                  </DraggableNode>
                )
              }}
              colors={['champagne1000']}
              axisBottom={{
                format: function (value: string) {
                  return value == '66' ? `> ${value}` : value
                },
              }}
              maxValue={maxY}
              keys={['count']}
              indexBy={INDEX_BY}
              data={numEmployeesByAge}
            />
          </Box>
        )}
      </Card.Content>
    </Card>
  )
}

export default WidgetAgeRangeDistribution
